import React, { useEffect, useRef, useState } from 'react';
import { Box, IconButton, Tooltip, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../../i18n/i18n';

// Reusable language switcher. Uses the same dropdown styling as the other header dropdowns.
const LanguageSwitcher = () => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentLanguage = i18n.resolvedLanguage || i18n.language;

  const handleSelect = code => {
    if (code !== currentLanguage) {
      i18n.changeLanguage(code);
    }
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <Box ref={dropdownRef} className="year-dropdown">
      <Tooltip title={t('header.changeLanguage')}>
        <Box
          className="year-dropdown-header"
          onClick={() => setIsOpen(prev => !prev)}
          sx={{
            p: '0!important',
            color: theme.palette.background.text,
            borderColor: theme.palette.custom.borderColor,
            backgroundColor: isOpen ? theme.palette.custom.listMenuhoverbg : 'transparent',
          }}
        >
          <IconButton
            className="head-icon-btn"
            aria-label={t('header.changeLanguage')}
            sx={{ color: theme.palette.background.text, borderColor: theme.palette.custom.borderColor }}
          >
            <i className="fa-sharp fa-regular fa-language fs-16"></i>
          </IconButton>
        </Box>
      </Tooltip>
      {isOpen && (
        <Box
          component="ul"
          className="year-dropdown-list"
          sx={{
            width: '170px!important',
            overflow: 'hidden',
            backgroundColor: theme.palette.background.bgwhite,
          }}
        >
          {SUPPORTED_LANGUAGES.map(lang => (
            <Box
              component="li"
              key={lang.code}
              onClick={() => handleSelect(lang.code)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '8px 20px!important',
                cursor: 'pointer',
                color: theme.palette.background.text,
                fontWeight: lang.code === currentLanguage ? 600 : 400,
                backgroundColor:
                  lang.code === currentLanguage ? theme.palette.custom?.listMenuhoverbg : 'transparent',
                '&:hover': {
                  backgroundColor: theme.palette.custom?.listMenuhoverbg || '#f0f0f0',
                },
              }}
            >
              <span>{lang.nativeLabel}</span>
              {lang.code === currentLanguage && <i className="fa-regular fa-check fs-12"></i>}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default LanguageSwitcher;
